import { Directive, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IDrawerSlot } from '../filter-drawer.types';
import { SlotRegistry } from './slot-registry.class';

@Directive()
export abstract class BaseSlotComponent implements OnInit {
    @Input() slot!: IDrawerSlot;
    @Input() formGroup!: FormGroup;

    ngOnInit() {
        const handler = SlotRegistry.getHandler(this.slot.type);
        handler.registerFormControl(this.formGroup, this.slot);
    }
}
